import { useEffect, useState } from 'react';


interface Props {
    error: any;
    isLoading: boolean;
}

// Keeps a query error until data is successfully fetched
export function useStickyError({ error, isLoading }: Props) {
    const [stickyError, setStickyError] = useState<any>(null);

    const shouldReset = !isLoading && !error;
    useEffect(() => {
        if (error) {
            setStickyError(error);
        } else if (shouldReset) {
            setStickyError(null);
        }
    }, [error, shouldReset]);

    const finalError = shouldReset ? null : (error ?? stickyError);
    return finalError;
}
